module.exports = __webpack_public_path__ + "static/media/UA.2a2f8934.png";